






















































































































/* tslint:disable */
import { SwExtendedVue } from '@sonicwall/unified-ui-framework/src/shared/sw-extended-vue';
import { Watch, Component } from 'vue-property-decorator';
import { Mutation } from 'vuex-class';
import { SetHelpContentIdPayload } from '@/core/core.store';
import { VuexMappedMutation } from '@libs-uuif/shared/common-types';
import {
  SwTable,
  TableEntry,
  TableColumnConfig,
  ColumnsAdjustRequestData,
  ColumnSortRequestData,
  SortedColumnInfo,
  TableFooterConfig,
  SwTableColumnSelection,
} from '@sonicwall/unified-ui-framework/src/shared/sw-table';
import { TableEntryFloatAction } from '@libs-uuif/shared/sw-table';
import { CreateElement, VNode } from 'vue';
import { SwDropMenu } from '@libs-uuif/shared/sw-drop-menu';
import { DropdownLight } from '../../shared/dropdown-light';
import UUIFComponent from '@/shared/uuifComponent';
import { SwDatetimePicker } from '@sonicwall/unified-ui-framework/src/shared/sw-datetime-picker';
import {
  SwExpandableTextfield,
  SwTextfield,
} from '@sonicwall/unified-ui-framework/src/shared/sw-textfield';
import { SwCheckbox } from '@libs-uuif/shared/sw-checkbox';
import MswAppTitle from '@/shared/msw-app-title/msw-app-title.vue';
import { SwRadio } from '@libs-uuif/shared/sw-radio';
import { SwScrollView } from '@libs-uuif/shared/sw-scroll-view';
import { SelectOption, SwSelect } from '@sonicwall/unified-ui-framework/src/shared/sw-select';
import { tooltip } from '@sonicwall/unified-ui-framework/src/shared/tooltip-dir';
import _ from 'lodash';
import { SwIconButton } from '@libs-uuif/shared/sw-icon-button';
import { SwIcon } from '@libs-uuif/shared/sw-icon';
import { ContentToolbarExpandFilterBlock } from '@sonicwall/unified-ui-framework/src/shared/sw-content-toolbar';
import { updateNotificationCountEventBus, UPDATE_NOTIFICATION_COUNT } from '../msw-alert-slider';
const cssPrefix = 'notification-center';

@Component({
  components: {
    ...UUIFComponent,
    SwTableColumnSelection,
    SwExpandableTextfield,
    SwDatetimePicker,
    DropdownLight,
    SwScrollView,
    MswAppTitle,
    SwTextfield,
    SwCheckbox,
    SwDropMenu,
    SwSelect,
    SwTable,
    SwRadio,
    SwIconButton,
    SwIcon,
  },
  directives: {
    tooltip,
  },
})
export default class NotificationCenterComponent extends SwExtendedVue {
  cssPrefix = cssPrefix;

  @Mutation
  setHelpContentId: VuexMappedMutation<SetHelpContentIdPayload>;

  isIframed: boolean = false;

  expandVisible: boolean = false;
  searchInputText = '';
  isExpandSearchFilter: boolean = false;
  filterBlockGrid: ContentToolbarExpandFilterBlock[][] = [];
  filterApplied: boolean = false;
  notificationType: string = '';
  notificationCategory: string = '';
  notificationDuration: string = '';
  tableLoader: boolean = false;

  // TABLE STUFF STARTS
  tableColConfig: TableColumnConfig[] = [];
  sortedColumns: SortedColumnInfo[] = [];
  adjustedColumns: ColumnsAdjustRequestData = {};

  selectedNotificationType: string = 'All';

  filterColumnKey: string = '';
  filterColumnValue: string = '';

  @Watch('searchInputText')
  searchInputTextChanged(val: any) {
    if (val === '') {
      this.setNotifications(this.notifications);
    }
  }

  get notifications() {
    return this.$store.getters['NotificationCenterStoreModule/getNotifications'];
  }

  get selectedNotifications() {
    return this.$store.getters['NotificationCenterStoreModule/getSelectedNotifications'];
  }

  get selectedNotificationsCount() {
    return this.$store.getters['NotificationCenterStoreModule/getSelectedNotificationsCount'];
  }

  get getNotificationTypes() {
    let notificationTypes: SelectOption[] = [];
    this.notifications.map((ele: any) => {
      notificationTypes.push({
        id: ele.notificationType,
        label: ele.notificationType,
        value: ele.notificationType,
      });
    });
    return notificationTypes;
  }

  onChangeNotificationType() {
    this.setNotifications(this.notifications);
  }

  get getTableData() {
    return this.selectedNotifications?.map((el: any, index: any) => {
      return {
        ...el,
        _key: index,
      };
    });
  }

  get gettableColConfig() {
    return this.tableColConfig;
  }

  get getTableHeight() {
    let remainsTableHeight = 315;
    if (this.isIframed) {
      remainsTableHeight = 80;
      if (this.expandVisible) {
        remainsTableHeight = 310;
      }
    } else {
      if (this.expandVisible) {
        remainsTableHeight = 550;
      }
    }
    return remainsTableHeight;
  }

  get getTableFooterConfig(): TableFooterConfig {
    const tableFooterConfig: TableFooterConfig = {
      render: (h: CreateElement) => {
        return (
          <div style='padding:10px; font-weight:700'>
            {`Total: ${this.selectedNotificationsCount} items`}
          </div>
        ) as VNode;
      },
    };
    return tableFooterConfig;
  }

  onToggleFilterExpand() {
    this.expandVisible = !this.expandVisible;
  }

  onRequestAdjustColumns(data: ColumnsAdjustRequestData) {
    this.adjustedColumns = data;
  }

  onRequestSorting(data: ColumnSortRequestData) {
    data.cancel = false;
    const index = this.sortedColumns.findIndex((col) => col.colKey === data.colKey);
    if (index < 0) {
      if (data.cancel) {
        return;
      }
      this.sortedColumns.splice(0);
      this.sortedColumns.push({
        colKey: data.colKey,
        ascending: !!data.ascending,
      });
    } else {
      if (data.ascending === undefined) {
        this.sortedColumns[index].ascending = !this.sortedColumns[index].ascending;
        return;
      }
      this.sortedColumns[index].ascending = !!data.ascending;
    }
  }

  async reloadData() {
    this.expandVisible = false;
    this.notificationType = '';
    this.notificationCategory = '';
    this.notificationDuration = '';
    this.getNotifications();
  }

  deleteNotification(notification: any) {
    this.$store
      .dispatch(
        'NotificationCenterStoreModule/deleteNotification',
        notification.notificationMsgId,
      )
      .then((resp) => {
        this.$store.commit('stopLoading');
        if (resp.operationStatus === 'OK') {
          this.getNotifications();
        } else {
          this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: resp?.msgDesc });
        }
      })
      .catch((error: any) => {
        this.$store.commit('stopLoading');
        this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: error?.msgDesc });
      });
  }

  unpinNotification(notification: any) {
    this.$store
      .dispatch(
        'NotificationCenterStoreModule/unpinNotification',
        notification.notificationMsgId,
      )
      .then((resp) => {
        this.$store.commit('stopLoading');
        if (resp.operationStatus === 'OK') {
          this.getNotifications();
        } else {
          this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: resp?.msgDesc });
        }
      })
      .catch((error: any) => {
        this.$store.commit('stopLoading');
        this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: error?.msgDesc });
      });
  }

  pinNotification(notification: any) {
    this.$store
      .dispatch(
        'NotificationCenterStoreModule/pinNotification',
        notification.notificationMsgId,
      )
      .then((resp) => {
        this.$store.commit('stopLoading');
        if (resp.operationStatus === 'OK') {
          this.getNotifications();
        } else {
          this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: resp?.msgDesc });
        }
      })
      .catch((error: any) => {
        this.$store.commit('stopLoading');
        this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: error?.msgDesc });
      });
  }

  /* tslint:disable-next-line */
  floatingActionsToShow(floatingActions: any, floatingActionsToRemove: any) {
    return floatingActions?.filter((ele: any, index: any) => {
      return floatingActionsToRemove?.indexOf(index) === -1;
    });
  }

  /* tslint:disable-next-line */
  getFloatActions(
    entry: TableEntry,
    index: number,
    scope: any = this,
  ): TableEntryFloatAction[] {
    const floatingActions = [
      {
        icon: { name: 'url', color: 'white' },
        action(entry: any) {
          window.open(scope.transformURL(entry.notificationUrl), entry.notificationUrlTarget);
        },
        tooltip: { content: entry.notificationText },
      },
      {
        icon: { name: 'pin', color: 'white' },
        action(entry: any) {
          scope.pinNotification(entry);
        },
        tooltip: {
          content: this.$t('notificationCenter.pinNotification')
          .toString(),
        },
      },
      {
        icon: { name: 'pin', color: 'white', rotate: 180 },
        action(entry: any) {
          scope.unpinNotification(entry);
        },
        tooltip: {
          content: this.$t('notificationCenter.unPinNotification')
          .toString(),
        },
      },
      {
        icon: { name: 'trash', color: 'white' },
        action(entry: any) {
          scope.deleteNotification(entry);
        },
        tooltip: {
          content: this.$t('notificationCenter.deleteNotification')
          .toString(),
        },
      },
    ];
    let floatingActionsToRemove: any = [];

    if (entry.notificationUrl !== undefined) {
      if (entry?.notificationUrl === '') {
        floatingActionsToRemove = [0];
        return this.floatingActionsToShow(floatingActions, floatingActionsToRemove);
      }
      if (entry.isUnPin) {
        floatingActionsToRemove = [1];
        return this.floatingActionsToShow(floatingActions, floatingActionsToRemove);
      }
      if (entry.isPin) {
        floatingActionsToRemove = [2];
        return this.floatingActionsToShow(floatingActions, floatingActionsToRemove);
      }
      if (entry.isDelete) {
        floatingActionsToRemove = [3];
        return this.floatingActionsToShow(floatingActions, floatingActionsToRemove);
      }
      return this.floatingActionsToShow(floatingActions, floatingActionsToRemove);
    } else {
      return [];
    }
  }

  setNotifications(notifications: any) {
    let selectedNotifications: any = [];
    notifications.forEach((ele: any) => {
      if (ele.notificationType === this.selectedNotificationType) {
        selectedNotifications = ele.messageRow;
      }
    });
    this.$store.commit(
      'NotificationCenterStoreModule/setSelectedNotifications',
      selectedNotifications,
    );
  }

  async getNotifications() {
    this.tableLoader = true;
    this.$store
      .dispatch('NotificationCenterStoreModule/getNotifications')
      .then((resp) => {
        // this.$store.commit('stopLoading');
        if (resp.operationStatus === 'OK') {
          let notifications = resp?.content?.notificationTypeList;
          this.getNotificationCountFromApi();
          this.$store.commit('NotificationCenterStoreModule/setNotifications', notifications);
          this.setNotifications(notifications);
        } else {
          this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: resp?.msgDesc });
        }
      })
      .catch((error: any) => {
        // this.$store.commit('stopLoading');
        this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: error?.msgDesc });
      })
      .finally(() => {
        this.tableLoader = false;
      });
  }

  async getNotificationCountFromApi() {
    const username = this.$store.getters.getUserId || '';
    try {
      const response = await this.$store.dispatch('getNotifyCount', username);
      if (response.operationStatus === 'OK') {
        updateNotificationCountEventBus.$emit(UPDATE_NOTIFICATION_COUNT, response.content.notificationCount || '');
        if (response.content.notificationCount &&
          window.location.href !== window.top.location.href) {
          window.parent.postMessage(
            {
              notificationCount: response.content.notificationCount || '0',
            },
            '*',
          );
        }
      }
    } catch (e) {
      console.error(e);
    } finally {
      this.$store.commit('stopLoading');
    }
  }

  makeTableConfig() {
    const makeElipsis = (item: string = '', size = 20) => {
      if (item.length > size) {
        return `${item.slice(0, size)}...`;
      }
      return item;
    };
    this.tableColConfig = [
      {
        key: 'Type',
        dataKey: 'Type',
        title: this.$t('products.type')
        .toString(),
        // width: 250,
        sorter: true,
        className: `${cssPrefix}__dataEntry`,
        // tslint:disable-next-line:no-unused
        render: (h: CreateElement, data: { entry: TableEntry }): VNode => {
          return (
            <div
              style='width: 100%;'
              v-tooltip={{
                placement: 'top',
                persistent: false,
                compact: true,
                content: data.entry.notificationClassificationText,
              }}
              on-mouseover={() => {
                this.filterColumnKey = data.entry._key;
                this.filterColumnValue = data.entry.notificationClassificationText;
              }}
              on-mouseleave={() => (this.filterColumnKey = '')}
            >
              {data.entry.notificationClassificationText || 'NA'}
              { this.filterColumnKey === data.entry._key &&
                this.filterColumnValue === data.entry.notificationClassificationText && (
                  <SwIcon
                    name='filter'
                    size={12}
                    style={{ marginLeft: '5px' }}
                    v-tooltip={{ content: 'Add Filter', compact: true, placement: 'bottom' }}
                    nativeOn-click={() => {
                      this.expandVisible = true;
                      this.notificationType = data.entry.notificationClassificationText;
                      this.applyFilters();
                    }}
                  ></SwIcon>
                )
              }
            </div>
          ) as VNode;
        },
      },
      {
        key: 'Category',
        dataKey: 'Category',
        title: this.$t('signatureIssues.catgry')
        .toString(),
        // width: 250,
        sorter: true,
        className: `${cssPrefix}__dataEntry`,
        // tslint:disable-next-line:no-unused
        render: (h: CreateElement, data: { entry: TableEntry }): VNode => {
          let iconClass = '';
          if (
            data.entry.notificationHeaderENText.toUpperCase() === 'SONICWALL SECURITY CENTER'
          ) {
            iconClass = 'major';
          } else if (
            data.entry.notificationHeaderENText.toUpperCase() ===
            'SITE AND INFRASTRUCTURE UPDATES'
          ) {
            iconClass = 'queue';
          } else if (
            data.entry.notificationHeaderENText.toUpperCase() ===
            'NEW PRODUCT AND FEATURE RELEASES'
          ) {
            iconClass = 'new';
          } else if (
            data.entry.notificationHeaderENText.toUpperCase() === 'SECURITY COMMUNITY'
          ) {
            iconClass = 'informational';
          } else if (
            data.entry.notificationHeaderENText.toUpperCase() === 'SONICWALL THREAT PROTECTION'
          ) {
            iconClass = 'critical';
          } else if (
            data.entry.notificationHeaderENText.toUpperCase() === 'SECURITY NOTICES'
          ) {
            iconClass = 'high';
          } else if (
            data.entry.notificationHeaderENText.toUpperCase() ===
            'NEW SOFTWARE AND FIRMWARE UPGRADES'
          ) {
            iconClass = 'new';
          } else if (
            data.entry.notificationHeaderENText.toUpperCase() == 'FIREWALL SECURITY'
          ) {
            iconClass = 'informational';
          }
          return (
            <div style='width: 100%; display:flex; align-items:center;justify-content:start;'
              on-mouseover={() => {
                this.filterColumnKey = data.entry._key;
                this.filterColumnValue = data.entry.notificationHeaderENText;
              }}
              on-mouseleave={() => (this.filterColumnKey = '')}
            >
              <span
                class={`sw-icon__inner sw-font-icon ${iconClass} ${data.entry.iconUrl}`}
                style='margin-right: 10px;'
              ></span>
              <div
                style='width: 100%;'
                v-tooltip={{
                  placement: 'top',
                  persistent: false,
                  compact: true,
                  content: data.entry.notificationHeaderENText,
                }}
              >
                {makeElipsis(data.entry.notificationHeaderENText, 25) || 'NA'}
                { this.filterColumnKey === data.entry._key &&
                  this.filterColumnValue === data.entry.notificationHeaderENText && (
                    <SwIcon
                      name='filter'
                      size={12}
                      style={{ marginLeft: '5px' }}
                      v-tooltip={{ content: 'Add Filter', compact: true, placement: 'bottom' }}
                      nativeOn-click={() => {
                        this.expandVisible = true;
                        this.notificationCategory = data.entry.notificationHeaderENText;
                        this.applyFilters();
                      }}
                    ></SwIcon>
                  )
                }
              </div>
            </div>
          ) as VNode;
        },
      },
      {
        key: 'Duration',
        dataKey: 'Duration',
        title: this.$t('notificationCenter.duration')
        .toString(),
        // width: 250,
        sorter: true,
        className: `${cssPrefix}__dataEntry`,
        // tslint:disable-next-line:no-unused
        render: (h: CreateElement, data: { entry: TableEntry }): VNode => {
          return (
            <div
              style='width: 100%;'
              v-tooltip={{
                placement: 'top',
                persistent: false,
                compact: true,
                content: data.entry.notificationCreatedDate,
              }}
              on-mouseover={() => {
                this.filterColumnKey = data.entry._key;
                this.filterColumnValue = data.entry.notificationCreatedDate;
              }}
              on-mouseleave={() => (this.filterColumnKey = '')}
            >
              {data.entry.notificationCreatedDate || 'NA'}
              { this.filterColumnKey === data.entry._key &&
                this.filterColumnValue === data.entry.notificationCreatedDate && (
                  <SwIcon
                    name='filter'
                    size={12}
                    style={{ marginLeft: '5px' }}
                    v-tooltip={{ content: 'Add Filter', compact: true, placement: 'bottom' }}
                    nativeOn-click={() => {
                      this.expandVisible = true;
                      this.notificationDuration = data.entry.notificationCreatedDate;
                      this.applyFilters();
                    }}
                  ></SwIcon>
                )
              }
            </div>
          ) as VNode;
        },
      },
      {
        key: 'Notification',
        dataKey: 'Notification',
        title: this.$t('notificationCenter.notification')
        .toString(),
        width: 550,
        sorter: true,
        className: `${cssPrefix}__dataEntry`,
        // tslint:disable-next-line:no-unused
        render: (h: CreateElement, data: { entry: TableEntry }): VNode => {
          return (
            <div
              style='width: 100%;'
              v-tooltip={{
                placement: 'top',
                persistent: false,
                compact: true,
                content: data.entry.notificationText,
              }}
            >
              {data.entry.notificationText || 'NA'}
            </div>
          ) as VNode;
        },
      },
    ];
  }

  mutateFilterState(name: any, event: any) {
    switch (name) {
      case 'type':
        this.notificationType = event;
        break;
      case 'category':
        this.notificationCategory = event;
        break;
      case 'duration':
        this.notificationDuration = event;
        break;
      case 'searchInputText':
        this.searchInputText = event;
        break;
    }
    if (
      !this.notificationType &&
      !this.notificationCategory &&
      !this.notificationDuration &&
      !this.searchInputText
    ) {
      this.setNotifications(this.notifications);
    }
  }

  handleSearchFilter() {
    if (this.searchInputText.trim() === '') {
      return;
    }
    let filteredNotifications = [];
    filteredNotifications = _.filter(this.selectedNotifications, (o: any) => {
      let flag = false;
      if (
        o.notificationClassificationText
          .toLowerCase()
          .indexOf(this.searchInputText.toLowerCase()) > -1 ||
        o.notificationHeaderENText.toLowerCase().indexOf(this.searchInputText.toLowerCase()) >
          -1 ||
        o.notificationCreatedDate.toLowerCase().indexOf(this.searchInputText.toLowerCase()) >
          -1
      ) {
        flag = true;
      }
      if (flag) {
        return o;
      }
    }) as TableEntry[];
    this.$store.commit(
      'NotificationCenterStoreModule/setSelectedNotifications',
      filteredNotifications,
    );
  }

  applyFilters() {
    let filteredNotifications = [];
    filteredNotifications = _.filter(this.selectedNotifications, (o: any) => {
      let flag = true;
      if (
        this.notificationType !== '' &&
        o.notificationClassificationText
          .toLowerCase()
          .indexOf(this.notificationType.toLowerCase()) === -1
      ) {
        flag = false;
      }
      if (
        this.notificationCategory !== '' &&
        o.notificationHeaderENText
          .toLowerCase()
          .indexOf(this.notificationCategory.toLowerCase()) === -1
      ) {
        flag = false;
      }
      if (
        this.notificationDuration !== '' &&
        o.notificationCreatedDate
          .toLowerCase()
          .indexOf(this.notificationDuration.toLowerCase()) === -1
      ) {
        flag = false;
      }
      if (flag) {
        return o;
      }
    }) as TableEntry[];
    this.$store.commit(
      'NotificationCenterStoreModule/setSelectedNotifications',
      filteredNotifications,
    );
  }

  private viewTypeRender(h: CreateElement): VNode {
    // tslint:disable-line
    return (
      <div>
        <SwTextfield
          {...{
            props: {
              name: 'type',
              value: this.notificationType,
              placeholder: this.$t('products.type')
              .toString(),
            },
            style: {
              width: '200px',
            },
            on: {
              keyup: (event: any) => {
                if (event.keyCode === 13) {
                  this.applyFilters();
                }
              },
              input: (event: any) => {
                this.mutateFilterState('type', event.trim());
              },
            },
          }}
        ></SwTextfield>
      </div>
    ) as VNode;
  }

  private viewCategoryRender(h: CreateElement): VNode {
    // tslint:disable-line
    return (
      <div>
        <SwTextfield
          {...{
            props: {
              name: 'category',
              value: this.notificationCategory,
              placeholder: this.$t('signatureIssues.catgry')
              .toString(),
            },
            style: {
              width: '200px',
            },
            on: {
              keyup: (event: any) => {
                if (event.keyCode === 13) {
                  this.applyFilters();
                }
              },
              input: (event: any) => {
                this.mutateFilterState('category', event.trim());
              },
            },
          }}
        ></SwTextfield>
      </div>
    ) as VNode;
  }

  private viewDurationRender(h: CreateElement): VNode {
    // tslint:disable-line
    return (
      <div>
        <SwTextfield
          {...{
            props: {
              name: 'duration',
              value: this.notificationDuration,
              placeholder: this.$t('notificationCenter.duration')
              .toString(),
            },
            style: {
              width: '200px',
            },
            on: {
              keyup: (event: any) => {
                if (event.keyCode === 13) {
                  this.applyFilters();
                }
              },
              input: (event: any) => {
                this.mutateFilterState('duration', event.trim());
              },
            },
          }}
        ></SwTextfield>
      </div>
    ) as VNode;
  }

  createFilterGrid() {
    const tableHeader = document.querySelector('.msw-table-toolbar') as HTMLElement;
    let totalWidth = 0;
    if (tableHeader) {
      totalWidth = tableHeader.getBoundingClientRect().width;
    }
    this.filterBlockGrid = [
      [
        {
          title: this.$t('products.type')
          .toString(),
          content: this.viewTypeRender,
          width: totalWidth / 3 || 200,
        },
        {
          title: this.$t('signatureIssues.catgry')
          .toString(),
          content: this.viewCategoryRender,
          width: totalWidth / 3 || 200,
        },
        {
          title: this.$t('notificationCenter.duration')
          .toString(),
          content: this.viewDurationRender,
          width: totalWidth / 3 || 200,
        },
      ],
    ];
  }

  checkifIframed() {
    this.$nextTick(() => {
      if (
        this.$route.query.mode &&
        this.$route.query.mode.toString().toLowerCase() === 'app'
      ) {
        this.isIframed = true;
      }
    });
  }

  transformURL(url:string) {
    if(url==undefined) {
      return '';
    }

    if (url.indexOf('.aspx') > 0) {
      const sessionId = JSON.parse(this.$store.getters.getUserInfo).user.sessionId;
      // if(this.userInfoService.isSandbox && (location.href.indexOf("snbuser=") > 0)){
      //     sessionId = this.userInfoService.getSNBSearchedUserSessionId();
      // }
      if (url.indexOf('?') == -1) {
        url = url + '?I=' + btoa(sessionId);
      } else {
        url = url + '&I=' + btoa(sessionId);
      }
    }


    if (window.location.hostname.toLowerCase().indexOf('localhost') >= 0)
    {
      return url.replace('~', window.location.protocol + '//' +  window.location.hostname + ':' + window.location.port).replace('/muir','');
    } else {
      console.warn('val is' + url);
      return url.replace('~', window.location.protocol + '//' + window.location.hostname);
    }
    return url;
  }

  // For title of the page
  get getHeaderConfig() {
    return {
      pageTitle: this.$t('browserTitles.notificationCenter')
      .toString(),
      pageParentName: this.$t('browserTitles.settings')
      .toString(),
      isFetchFromProps: true,
    };
  }

  created() {
    this.setHelpContentId({ helpId: ['notification-center'] });
  }

  mounted() {
    this.checkifIframed();
    this.createFilterGrid();
    this.makeTableConfig();
    this.getNotifications();
  }
}
